import { jsx as o } from "react/jsx-runtime";
import r from "react";
import e from "styled-components";
const t = e.div.withConfig({
  displayName: "Badge",
  componentId: "sc-dfotfi-0"
})(["position:relative;border-radius:var(--border-radius-circular);background-color:var(--elements-notification-color);width:var(--size-1x);height:var(--size-1x);"]), d = r.forwardRef(({}, a) => /* @__PURE__ */ o(t, { ref: a, "data-testid": "rango-badge", "data-rango-component": "rango-badge", "data-is-rango": !0 }));
d.displayName = "RangoBadge";
export {
  d as RangoBadge
};
